import { render, staticRenderFns } from "./LoaderCircle.vue?vue&type=template&id=34b45661&"
import script from "./LoaderCircle.vue?vue&type=script&lang=ts&"
export * from "./LoaderCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports